export default __webpack_public_path__ + "static/media/ic-technology.23d13a0c.svg";